/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateServiceAgreementResponse
 */
export interface CreateServiceAgreementResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateServiceAgreementResponse
     */
    processInstanceId?: string;
}

/**
 * Check if a given object implements the CreateServiceAgreementResponse interface.
 */
export function instanceOfCreateServiceAgreementResponse(value: object): value is CreateServiceAgreementResponse {
    return true;
}

export function CreateServiceAgreementResponseFromJSON(json: any): CreateServiceAgreementResponse {
    return CreateServiceAgreementResponseFromJSONTyped(json, false);
}

export function CreateServiceAgreementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceAgreementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'processInstanceId': json['processInstanceId'] == null ? undefined : json['processInstanceId'],
    };
}

export function CreateServiceAgreementResponseToJSON(json: any): CreateServiceAgreementResponse {
    return CreateServiceAgreementResponseToJSONTyped(json, false);
}

export function CreateServiceAgreementResponseToJSONTyped(value?: CreateServiceAgreementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processInstanceId': value['processInstanceId'],
    };
}

